import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/_auth/budgets/_layout/$fiscalYear/$budgetId/_layout/")({
  loader: async ({ params, parentMatchPromise }) => {
    if ((await parentMatchPromise).fullPath === "/budgets/$fiscalYear/$budgetId") {
      throw redirect({
        to: "/budgets/$fiscalYear/$budgetId/target",
        params,
      })
    }
    return null
  },
})
